import { NgModule } from '@angular/core';
import { PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface} from '@harvest-dev/ng-perfect-scrollbar';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CarouselModule } from 'ngx-owl-carousel-o';
// import { NgxMaterialTimepickerModule} from 'ngx-material-timepicker';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { AlertComponent } from '../shared/alert/alert.component';
import { LoaderComponent } from '../shared/loader/loader.component';
import { ShortNamePipe } from '../shared/shortname';
import { InitialsPipe } from '../shared/initials';




const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    minScrollbarLength: 20,
    maxScrollbarLength: 80
  };

@NgModule({
    declarations: [
        LoaderComponent,
        AlertComponent,
        ShortNamePipe,
        InitialsPipe
    ],
    imports: [
        BsDatepickerModule.forRoot(),
        PopoverModule.forRoot(),
        PerfectScrollbarModule,
        NgbModule,
        CarouselModule,
        // NgxMaterialTimepickerModule,
    ],
    exports: [
        PerfectScrollbarModule,
        NgbModule,
        CarouselModule,
        // NgxMaterialTimepickerModule,
        BsDatepickerModule,
        PopoverModule,
        AlertComponent,
        LoaderComponent,
        ShortNamePipe,
        InitialsPipe
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
    ]
})


export class AppPluginsModule { 



  
}

